<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import {getWechatInfo} from "./util/weChat";
    import {getInfoByOpenIDService, getInfoByCodeService, getStageBalanceService} from './service/userService';
    import {getUrlParamsTools, isWeixinOrAlipayTools} from './util/tools';
    import Cookies from 'js-cookie';
    import {Toast} from 'vant';
	
    export default {
        data() {
            return {}
        },
        created() {
            const isWeixinOrAlipay = isWeixinOrAlipayTools();
            console.log(isWeixinOrAlipay)
            //微信打开
            if (isWeixinOrAlipay === 'WeiXIN') {
                const oTel = Cookies.get('o_tel'),
                        oId = Cookies.get('o_id');
                    if (oId) {
                        console.log('走缓存');
                        this.setOpenID(oId);
                        if (oTel) {
                            getStageBalanceService(oTel, data => {
                                if (data.status === 1) {
                                    getInfoByOpenIDService(oTel, res => {
                                        this.setUserInfo(res);
                                    })
                                } else {
                                    Toast(data.msg);
                                }
                            })
                        }
                    } else {
                        console.log('获取code值');
                        this.getWechat();
                    }
                // const state = getUrlParamsTools('isPhone');
                // if (state) {
                //     const tel = getUrlParamsTools('tel');
                //     if (tel) {
                //         getStageBalanceService(tel, res => {
                //             if (res.status === 1) {
                //                 getInfoByOpenIDService(tel, res => {
                //                     this.setUserInfo(res);
                //                 })
                //             } else {
                //                 Toast(res.msg);
                //             }
                //         });
                //     }
                // } else {
                //     const oTel = Cookies.get('o_tel'),
                //         oId = Cookies.get('o_id');
                //     if (oId) {
                //         this.setOpenID(oId);
                //         if (oTel) {
                //             getStageBalanceService(oTel, data => {
                //                 if (data.status === 1) {
                //                     getInfoByOpenIDService(oTel, res => {
                //                         this.setUserInfo(res);
                //                     })
                //                 } else {
                //                     Toast(data.msg);
                //                 }
                //             })
                //         }
                //     } else {
                //         this.getWechat();
                //     }
                // }
            } else {
                console.log('支付宝打开');
                const state = getUrlParamsTools('isPhone');
                if (state) {
                    const tel = getUrlParamsTools('tel');
                    if (tel) {
                        getStageBalanceService(tel, res => {
                            if (res.status === 1) {
                                getInfoByOpenIDService(tel, res => {
                                    console.log(res)
                                    this.setUserInfo(res);
                                })
                            } else {
                                Toast(res.msg);
                            }
                        });
                    }
                } else {
                    const oTel = Cookies.get('o_tel'),
                        oId = Cookies.get('o_id');
                    if (oId) {
                        this.setOpenID(oId);
                        if (oTel) {
                            getStageBalanceService(oTel, data => {
                                if (data.status === 1) {
                                    getInfoByOpenIDService(oTel, res => {
                                        console.log(res)

                                        this.setUserInfo(res);
                                    })
                                } else {
                                    Toast(data.msg);
                                }
                            })
                        }
                    }
                }
            }

        },
        methods: {
            ...mapActions(['setUserInfo', 'setOpenID']),
            getWechat() {
                getWechatInfo(code => {
                    getInfoByCodeService(code, res => {
                        Cookies.set('o_tel', res.tel);
                        Cookies.set('o_id', res.openid);
                        getStageBalanceService(res.tel, data => {
                            if (data.status === 1) {
                                res.red_balance = data.datas.red_balance;
                                this.setUserInfo(res);
                            } else {
                                Toast(data.msg);
                            }
                        });
                    });
                })
            },
        },
        components: {},
    }

</script>
<style lang="scss">
    #app {
        height: 100%;

        .wrapper {
            height: 100%;
            background: #F6F4F4;

            .header {
                padding-bottom: 46px;
            }

            .content {
                background: #F6F4F4;
            }
        }
    }
</style>
